'use client';

import * as React from 'react';
import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { UnstableTemporalAdapterDateFns } from "../base-ui-copy/temporal-adapter-date-fns/index.mjs";
import { SchedulerStoreContext } from "../use-scheduler-store-context/useSchedulerStoreContext.mjs";
const DEFAULT_ADAPTER = new UnstableTemporalAdapterDateFns();
const getAdapter = state => state.adapter;

/**
 * Reads the adapter from the nearest scheduler store context.
 * Use this in child components instead of `useAdapter()`.
 * Falls back to the default adapter when used outside a store context (e.g. in unit tests).
 */
export function useAdapterContext() {
  const store = React.useContext(SchedulerStoreContext);
  const subscribe = React.useCallback(cb => store ? store.subscribe(cb) : () => {}, [store]);
  const getSnapshot = React.useCallback(() => store ? getAdapter(store.state) : DEFAULT_ADAPTER, [store]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}